import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { formatMoneda, formatoMonto, validaMonto, validaSoloNumero } from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';
import CatalogoCompromisos from '../../catalogos/catalogoCompromisos';
import CatalogoImputaciones from '../../catalogos/catalogoImputaciones';
import CatalogoSolicitudObras from '../../catalogos/catalogoSolicitudObras';
import CatalogoSolicitudDonaciones from '../../catalogos/catalogoSolicitudDonaciones';
import CatalogoSolicitudTraslado from '../../catalogos/catalogoSolicitudTrasFT';

export const AgregarCompromiso = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const idusuario = JSON.parse(localStorage.getItem('idusuario'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [mostrar4, setMostrar4] = useState(false);
    const [val, setVal] = useState(0);
    const [val2, setVal2] = useState(0);
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtId = useRef();
    const txtIdcor = useRef();
    const txtIdprov = useRef();
    const txtFecha = useRef();
    const txtObserv = useRef();
    const txtDescriclas = useRef();
    const txtMonto = useRef();
    const txtMontoiv = useRef();
    const txtFechacrea = useRef();
    const txtTipo = useRef();
    const txtMotivo = useRef();

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        setActivate(false);
        setActivo(true);
    };


    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onHideRenderizar();
        props.onHideCancelar();
        blanquear();
    }

    const catalogoClass = (e) => {
        e.preventDefault();
        setMostrar4(true);
    };

    const handleInputNumChange = (event) => {
        event.preventDefault();
        validaSoloNumero(event);

        if (event.which === 13 || typeof (event.which) === 'undefined') {


        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const handleAceptaCompromiso = (idcompromiso, tipo, referencia, fecha, idproveedor, idcoordinacion, idefiscal, concepto, reversado, montocompromiso,
        ubicacion, status, montoiva, fechafactura, nrofactura, nrocontrol, idusuario_crea, fecha_crea, fecha_reverso,
        idusuario_reversa, idtipopago, iddatpresu, observacion) => {
        setMostrar4(false);
        var valida = 1;
        if (props.retorno.length > 0) {

            for (let i = 0; i < props.retorno.length; i++) {

                if (idcompromiso !== props.retorno[i].idordenpago) {
                    txtId.current.value = idcompromiso;
                    txtDescriclas.current.value = concepto.trim();
                    txtIdcor.current.value = idcoordinacion;
                    txtIdprov.current.value = idproveedor;
                    txtFecha.current.value = moment.utc(fecha).format('DD-MM-YYYY');
                    txtObserv.current.value = observacion.trim();
                    txtMonto.current.value = montocompromiso;
                    txtMontoiv.current.value = montoiva;
                    txtFechacrea.current.value = moment.utc(fecha_crea).format('DD-MM-YYYY');
                    txtTipo.current.value = tipo;
                } else {
                    valida = 7;
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Este Compromiso ya fue Seleccionado !', icono: 'informacion' });
                }

                if (valida === 7) {
                    txtId.current.value = '';
                    txtDescriclas.current.value = '';
                    txtIdcor.current.value = '';
                    txtIdprov.current.value = '';
                    txtFecha.current.value = '';
                    txtObserv.current.value = '';
                    txtFechacrea.current.value = '';
                    txtTipo.current.value = '';
                    txtMonto.current.value = '';
                    txtMontoiv.current.value = '';
                }

            }

        } else {
            txtId.current.value = idcompromiso;
            txtDescriclas.current.value = concepto.trim();
            txtIdcor.current.value = idcoordinacion;
            txtIdprov.current.value = idproveedor;
            txtFecha.current.value = moment.utc(fecha).format('DD-MM-YYYY');
            txtObserv.current.value = observacion.trim();
            txtMonto.current.value = montocompromiso;
            txtMontoiv.current.value = montoiva;
            txtFechacrea.current.value = moment.utc(fecha_crea).format('DD-MM-YYYY');
            txtTipo.current.value = tipo;
        }


        if (idcompromiso > 0) {
            setVal(1);
        } else {
            setVal(2);
        }

        setActivo(false);

    }

    const handleAceptaOrdeImputacion = (tipodocumento, codigoorden, tipoorden, idordencompra, status, fecha, observaciones, tipo, concepto, escredito,
        numcontrol, idefiscal, monto, montoiva, idproveedor, idcordinacion, idusuario_crea, fecha_crea, fecha_reverso, idusuario_reversa,
        reversado, motivo, razonsocial, idordenservicio) => {
        setMostrar4(false);
        var valida = 1;
        if (props.retorno.length > 0) {

            for (let i = 0; i < props.retorno.length; i++) {

                if (codigoorden || idordenservicio !== props.retorno[i].idordenpago) {
                    txtId.current.value = codigoorden !== null ? codigoorden : idordenservicio;
                    txtDescriclas.current.value = concepto.trim();
                    txtIdcor.current.value = idcordinacion;
                    txtIdprov.current.value = idproveedor;
                    txtFecha.current.value = moment.utc(fecha).format('DD-MM-YYYY');
                    txtObserv.current.value = observaciones.trim();
                    txtMonto.current.value = monto;
                    txtMontoiv.current.value = montoiva;
                    txtFechacrea.current.value = moment.utc(fecha_crea).format('DD-MM-YYYY');
                    txtTipo.current.value = tipo;
                    setVal2(idordenservicio !== null ? 2 : idordencompra !== null ? 1 : 3);
                } else {
                    valida = 7;
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Este Documento ya fue Seleccionado !', icono: 'informacion' });
                }

                if (valida === 7) {
                    txtId.current.value = '';
                    txtDescriclas.current.value = '';
                    txtIdcor.current.value = '';
                    txtIdprov.current.value = '';
                    txtFecha.current.value = '';
                    txtObserv.current.value = '';
                    txtFechacrea.current.value = '';
                    txtTipo.current.value = '';
                    txtMonto.current.value = '';
                    txtMontoiv.current.value = '';
                }

            }

        } else {
            setVal2(idordenservicio !== null ? 2 : idordencompra !== null ? 1 : 3);
            txtId.current.value = codigoorden !== null ? codigoorden : idordenservicio;
            txtDescriclas.current.value = concepto.trim();
            txtIdcor.current.value = idcordinacion;
            txtIdprov.current.value = idproveedor;
            txtFecha.current.value = moment.utc(fecha).format('DD-MM-YYYY');
            txtObserv.current.value = observaciones.trim();
            txtMonto.current.value = monto;
            txtMontoiv.current.value = montoiva;
            txtFechacrea.current.value = moment.utc(fecha_crea).format('DD-MM-YYYY');
            txtTipo.current.value = tipo;
        }


        if (codigoorden > 0) {
            setVal(1);
        } else {
            setVal(2);
        }

        setActivo(false);

    }

    const handleAceptaSolicitudObras = (idsolicitudpagoobras, idobraasignada, status, fecha, observaciones, tipo, concepto, idefiscal) => {
        setMostrar4(false);
        var valida = 1;
        if (props.retorno.length > 0) {

            for (let i = 0; i < props.retorno.length; i++) {

                if (idsolicitudpagoobras !== props.retorno[i].idordenpago) {
                    txtId.current.value = idsolicitudpagoobras;
                    txtDescriclas.current.value = observaciones.trim();
                    txtIdcor.current.value = idobraasignada;
                    txtIdprov.current.value = 0;
                    txtFecha.current.value = moment.utc(fecha).format('DD-MM-YYYY');
                    txtObserv.current.value = concepto.trim();
                    txtMonto.current.value = 0.00;
                    txtMontoiv.current.value = 0.00;
                    txtFechacrea.current.value = "";
                    txtTipo.current.value = tipo;
                } else {
                    valida = 7;
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Este Documento ya fue Seleccionado !', icono: 'informacion' });
                }

                if (valida === 7) {
                    txtId.current.value = '';
                    txtDescriclas.current.value = '';
                    txtIdcor.current.value = '';
                    txtIdprov.current.value = '';
                    txtFecha.current.value = '';
                    txtObserv.current.value = '';
                    txtFechacrea.current.value = '';
                    txtTipo.current.value = '';
                    txtMonto.current.value = '';
                    txtMontoiv.current.value = '';
                }

            }

        } else {
            txtId.current.value = idsolicitudpagoobras;
            txtDescriclas.current.value = observaciones.trim();
            txtIdcor.current.value = idobraasignada;
            txtIdprov.current.value = 0;
            txtFecha.current.value = moment.utc(fecha).format('DD-MM-YYYY');
            txtObserv.current.value = concepto.trim();
            txtMonto.current.value = 0.00;
            txtMontoiv.current.value = 0.00;
            txtFechacrea.current.value = "";
            txtTipo.current.value = tipo;
        }


        if (idsolicitudpagoobras > 0) {
            setVal(1);
        } else {
            setVal(2);
        }

        setActivo(false);

    }

    const handleAceptaSolicitudDonaciones = (status, fecha, observaciones, tipo, concepto, escredito, numcontrol, idefiscal, monto, montoiva,
        idproveedor, idcordinacion, fecha_crea, fecha_reverso, reversado, motivo, observacion, iddatosresponsables,
        idprecompromisoaso, idordendonacion, razonsocial) => {
        setMostrar4(false);
        var valida = 1;
        if (props.retorno.length > 0) {

            for (let i = 0; i < props.retorno.length; i++) {

                if (idordendonacion !== props.retorno[i].idordenpago) {
                    txtId.current.value = idordendonacion;
                    txtDescriclas.current.value = observaciones.trim();
                    txtIdcor.current.value = idcordinacion;
                    txtIdprov.current.value = idproveedor;
                    txtFecha.current.value = moment.utc(fecha).format('DD-MM-YYYY');
                    txtObserv.current.value = concepto.trim();
                    txtMonto.current.value = monto;
                    txtMontoiv.current.value = montoiva;
                    txtFechacrea.current.value = moment.utc(fecha_crea).format('DD-MM-YYYY');
                    txtTipo.current.value = tipo;
                } else {
                    valida = 7;
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Este Documento ya fue Seleccionado !', icono: 'informacion' });
                }

                if (valida === 7) {
                    txtId.current.value = '';
                    txtDescriclas.current.value = '';
                    txtIdcor.current.value = '';
                    txtIdprov.current.value = '';
                    txtFecha.current.value = '';
                    txtObserv.current.value = '';
                    txtFechacrea.current.value = '';
                    txtTipo.current.value = '';
                    txtMonto.current.value = '';
                    txtMontoiv.current.value = '';
                }

            }

        } else {
            txtId.current.value = idordendonacion;
            txtDescriclas.current.value = observaciones.trim();
            txtIdcor.current.value = idcordinacion;
            txtIdprov.current.value = idproveedor;
            txtFecha.current.value = moment.utc(fecha).format('DD-MM-YYYY');
            txtObserv.current.value = concepto.trim();
            txtMonto.current.value = monto;
            txtMontoiv.current.value = montoiva;
            txtFechacrea.current.value = moment.utc(fecha_crea).format('DD-MM-YYYY');
            txtTipo.current.value = tipo;
        }


        if (idordendonacion > 0) {
            setVal(1);
        } else {
            setVal(2);
        }

        setActivo(false);

    }

    const handleAceptaSolicitudTraslado = (values) => {
        setMostrar4(false);

        if (props.retorno.length > 0) {

            for (let i = 0; i < props.retorno.length; i++) {

                if (values.idaprobacion !== props.retorno[i].idaprobacion) {
                    txtId.current.value = values.idaprobacion;
                    txtDescriclas.current.value = values.descripaprobacion.trim();
                    txtIdcor.current.value = values.idobraasignada;
                    txtIdprov.current.value = 0;
                    txtFecha.current.value = moment.utc(values.fechaaprobacion).format('DD-MM-YYYY');
                    txtObserv.current.value = '';
                    txtMonto.current.value = 0.00;
                    txtMontoiv.current.value = 0.00;
                    txtFechacrea.current.value = "";
                    txtTipo.current.value = 0;
                } else {
                    valida = 7;
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Este Documento ya fue Seleccionado !', icono: 'informacion' });
                }

                if (valida === 7) {
                    txtId.current.value = '';
                    txtDescriclas.current.value = '';
                    txtIdcor.current.value = '';
                    txtIdprov.current.value = '';
                    txtFecha.current.value = '';
                    txtObserv.current.value = '';
                    txtFechacrea.current.value = '';
                    txtTipo.current.value = '';
                    txtMonto.current.value = '';
                    txtMontoiv.current.value = '';
                }

            }

        } else {
            txtId.current.value = values.idaprobacion;
            txtDescriclas.current.value = values.descripaprobacion.trim();
            txtIdcor.current.value = values.idobraasignada;
            txtIdprov.current.value = 0;
            txtFecha.current.value = moment.utc(values.fechaaprobacion).format('DD-MM-YYYY');
            txtObserv.current.value = '';
            txtMonto.current.value = 0.00;
            txtMontoiv.current.value = 0.00;
            txtFechacrea.current.value = "";
            txtTipo.current.value = 0;
        }


        if (values.idaprobacion > 0) {
            setVal(1);
        } else {
            setVal(2);
        }

        setActivo(false);


        /* if (
            records.some(
                (record) =>
                    record.idaprobacion.toString() === values.idaprobacion.toString()
            )
        ) {
            setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "Ya esta orden de pago fue agregada.",
                icono: "informacion",
            });
        } else {
            setRecords([...records, values]);
        } */
    };

    const handleCancelaras = () => {
        setMostrar4(false);
    }

    const seleccionarCompromiso = (id) => {


        let endpoint = `${op.conexion}/api/presupuesto/registroscompromisosinput?idefiscal=${idefiscal}&tipo=${0}&ubi=${props.ubica}&estatus=${0}&reversa=${0}&idcomp=${id}`;
        console.log(endpoint)
        setActivate(true);

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status === 200) {

                if (response.data.idcompromiso > 0) {

                    var valida = 1;
                    if (props.retorno.length > 0) {

                        for (let i = 0; i < props.retorno.length; i++) {

                            if (response.data.idcompromiso !== props.retorno[i].idordenpago) {
                                txtId.current.value = response.data.idcompromiso;
                                txtDescriclas.current.value = response.data.concepto;
                                txtIdcor.current.value = response.data.idcoordinacion;
                                txtIdprov.current.value = response.data.idproveedor;
                                txtFecha.current.value = moment.utc(response.data.fecha).format('DD-MM-YYYY');
                                txtObserv.current.value = response.data.observacion;
                                txtMonto.current.value = response.data.montocompromiso;
                                txtMontoiv.current.value = response.data.montoiva;
                                txtFechacrea.current.value = moment.utc(response.data.fecha_crea).format('DD-MM-YYYY');
                                txtTipo.current.value = response.data.tipo;
                            } else {
                                valida = 7;
                                setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Este Compromiso ya fue Seleccionado !', icono: 'informacion' });
                            }

                            if (valida === 7) {
                                txtId.current.value = '';
                                txtDescriclas.current.value = '';
                                txtIdcor.current.value = '';
                                txtIdprov.current.value = '';
                                txtFecha.current.value = '';
                                txtObserv.current.value = '';
                                txtFechacrea.current.value = '';
                                txtTipo.current.value = '';
                                txtMonto.current.value = '';
                                txtMontoiv.current.value = '';
                            }

                        }

                    } else {
                        txtId.current.value = response.data.idcompromiso;
                        txtDescriclas.current.value = response.data.concepto;
                        txtIdcor.current.value = response.data.idcoordinacion;
                        txtIdprov.current.value = response.data.idproveedor;
                        txtFecha.current.value = moment.utc(response.data.fecha).format('DD-MM-YYYY');
                        txtObserv.current.value = response.data.observacion;
                        txtMonto.current.value = response.data.montocompromiso;
                        txtMontoiv.current.value = response.data.montoiva;
                        txtFechacrea.current.value = moment.utc(response.data.fecha_crea).format('DD-MM-YYYY');
                        txtTipo.current.value = response.data.tipo;
                    }


                    if (response.data.idcompromiso > 0) {
                        setVal(1);
                    } else {
                        setVal(2);
                    }

                    setActivo(false);

                } else {
                    setActivo(true);
                    setVal(2);
                    txtId.current.value = '';
                    txtDescriclas.current.value = '';
                    txtIdcor.current.value = '';
                    txtIdprov.current.value = '';
                    txtFecha.current.value = '';
                    txtObserv.current.value = '';
                    txtMonto.current.value = '';
                    txtMontoiv.current.value = '';
                    txtFechacrea.current.value = '';
                    txtTipo.current.value = '';
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Compromiso no existe', icono: 'informacion' });
                }
                setActivate(false);
            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });

    }

    const handleSolicitudes = (event) => {
        event.preventDefault();
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                seleccionarCompromiso(event.target.value);
            }
        }
    };

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (props.devolver === 0) {
            if (txtMotivo.current.value.trim() === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Debe Describir el Motivo !', icono: 'informacion' });
                sigue = false;
                txtMotivo.current.focus();
            } else {
                seleccionarSolicitudesCompras();
            }

        } else if (sigue) {

            seleccionarSolicitudesCompras();

        }

    };

    const seleccionarSolicitudesCompras = () => {
        blanquear();
        var datos = [];
        if (props.devolver === 0) {
            datos.push({
                idcordinacion: txtIdcor.current.value,
                concepto: txtDescriclas.current.value.trim(),
                idproveedor: txtIdprov.current.value,
                idordencompra: txtId.current.value,
                fecha: txtFecha.current.value,
                observaciones: txtObserv.current.value.trim(),
                monto: txtMonto.current.value,
                montoiva: txtMontoiv.current.value,
                fechacrea: txtFechacrea.current.value,
                tipo: txtTipo.current.value,
                motivodevol: txtMotivo.current.value.trim(),
                val: val,
                validaparam: val2
            })
        } else {
            datos.push({
                idcordinacion: txtIdcor.current.value,
                concepto: txtDescriclas.current.value.trim(),
                idproveedor: txtIdprov.current.value,
                idordencompra: txtId.current.value,
                fecha: txtFecha.current.value,
                observaciones: txtObserv.current.value.trim(),
                monto: txtMonto.current.value,
                montoiva: txtMontoiv.current.value,
                fechacrea: txtFechacrea.current.value,
                tipo: txtTipo.current.value,
                motivodevol: "",
                val: val,
                validaparam: val2
            })
        }

        props.onDatos(datos);
        props.onHideCancela();
    };

    const onChange = (e) => {

        if (e.target.name === 'descriaux' || e.target.name === 'ubicacion' || e.target.name === 'observacion') {
            e.target.value = e.target.value.toUpperCase();
        }

        if (e.target.name === 'codigo') {
            txtDescriclas.current.value = '';

        }

    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                if (props.operacion === 1) {
                    console.log(props.retorno);
                    console.log(props.devolver);
                } else {
                    txtId.current.value = '';
                    txtDescriclas.current.value = '';
                    txtIdcor.current.value = '';
                    txtIdprov.current.value = '';
                    txtFecha.current.value = '';
                    txtObserv.current.value = '';
                    txtMonto.current.value = '';
                    txtMontoiv.current.value = '';
                    txtFechacrea.current.value = '';
                    txtTipo.current.value = '';
                }

            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{props.devolver === 0 ? 'Documento a Desaprobar' : 'Documento a Aprobar'}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>

                <div>
                    {props.ubica === 90 && props.tipocom === 7 ? <CatalogoImputaciones
                        show={mostrar4}
                        estatus={0}
                        aprueba={false}
                        titleselect={'[Imputación]'}
                        onHideCancelar={handleCancelaras}
                        onHideAceptarCompromiso={handleAceptaOrdeImputacion}
                    /> : props.ubica === 40 && props.tipocom === 2 ? <CatalogoImputaciones
                        show={mostrar4}
                        estatus={1}
                        aprueba={false}
                        titleselect={'[Compras]'}
                        onHideCancelar={handleCancelaras}
                        onHideAceptarCompromiso={handleAceptaOrdeImputacion}
                    /> : props.ubica === 40 && props.tipocom === 3 ? <CatalogoSolicitudObras
                        show={mostrar4}
                        estatus={1}
                        onHideCancelar={handleCancelaras}
                        onHideAceptarCompromiso={handleAceptaSolicitudObras}
                    /> : props.ubica === 95 && props.tipocom === 7 ? <CatalogoSolicitudDonaciones
                        show={mostrar4}
                        estatus={1}
                        reversa={0}
                        onHideCancelar={handleCancelaras}
                        onHideAceptarCompromiso={handleAceptaSolicitudDonaciones}
                    /> : props.ubica === 1 && props.tipocom === 4 ? <CatalogoSolicitudTraslado
                        show={mostrar4}
                        estatus={props.devolver === 1 ? 0 : 1}
                        reversa={0}
                        desde={1}
                        onHideCancela={handleCancelaras}
                        onHideAceptaCatalogo={handleAceptaSolicitudTraslado}
                    /> : <CatalogoCompromisos
                        show={mostrar4}
                        tipo={props.tipo}
                        ubi={props.ubica}
                        sta={0}
                        rever={0}
                        onHideCancelar={handleCancelaras}
                        onHideAceptarCompromiso={handleAceptaCompromiso}
                    />}
                </div>


                <Dimmer active={activate} inverted>

                </Dimmer>
                <div>

                    <input type='hidden' ref={txtIdcor} />
                    <input type='hidden' ref={txtIdprov} />
                    <input type='hidden' ref={txtFecha} />
                    <input type='hidden' ref={txtObserv} />
                    <input type='hidden' ref={txtMonto} />
                    <input type='hidden' ref={txtMontoiv} />
                    <input type='hidden' ref={txtFechacrea} />
                    <input type='hidden' ref={txtTipo} />


                    <div className='col-md-12 py-2'></div>

                    <fieldset className="row border-azul rounded mx-auto">
                        <legend className="float-none m-0 w-auto" >Incluir Documento</legend>

                        <div className='container row m-0 d-flex justify-content-center col-12 mx-auto px-0'>

                            <div className='mb-2'></div>


                            <div className='col-sm-3 mb-2 px-1'>
                                <div className="input-group input-group-sm m-0 w-100">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Código:</label>
                                    <input type="text" name='codigo' disabled={(props.ubica === 90 && props.tipocom === 7) || props.devolver === 1 || props.tipocom === 4 ? true : false} ref={txtId} onKeyUp={handleSolicitudes} onChange={onChange} onBlur={handleInputNumChange} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />
                                    <button disabled={operacion === 4 || operacion === 2 ? true : deshabilitado} onClick={catalogoClass} className="btn btn-sm  btn-info" ><i className="fa fa-search"></i> </button>
                                </div>
                            </div>

                            <div className='col-sm-9 px-1'>
                                <div className='col-sm-12 mb-2 px-0'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Concepto:</label>
                                        <textarea type="text" className="form-control text-uppercase" style={{ height: '60px' }} disabled={true} ref={txtDescriclas} placeholder="Descripción del Documento" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputDireccion" />
                                    </div>
                                </div>
                            </div>

                            {props.devolver === 0 ?
                                <div className='col-sm-12 mb-2 px-0'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Motivo:</label>
                                        <textarea type="text" className="form-control text-uppercase" style={{ height: '60px' }} disabled={props.devolver !== 0 ? true : false} ref={txtMotivo} placeholder="Descripción del Motivo" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputDireccion" />
                                    </div>
                                </div> : ''}

                        </div>

                    </fieldset>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} onClick={onChangeValidar} disabled={activo} style={{ margin: '1px' }} className="fw-bold btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Aceptar</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="fw-bold btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />

        </Modal>

    );
}